<template>
  <div class="">
    <Header></Header>
    <div class="contain" style="margin-top: 20px;">
    <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'AppResourceAdd', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
    
    <div class="form_btm">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="文件名称" prop="title">
          <el-input v-model="form.title" ></el-input>
        </el-form-item>
        <el-form-item label="文件说明" prop="desc">
          <el-input type="textarea" v-model="form.desc" ></el-input>
        </el-form-item>
        
        <el-form-item label="所属学段" prop="class_id" >
          <el-radio-group v-model="form.class_id" @input="selectNianji">
            <el-radio v-for="item of GradeList" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属科目" prop="subject_id">
          <el-radio-group v-model="form.subject_id" placeholder="请选择上传文件所属的科目">
            <el-radio
              v-for="(item, key) in CourseList"
              :key="item.id"
              :label="item.id"
              :value="item.id">
             {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文件类型" prop="type_id">
          <el-radio-group v-model="form.type_id"  placeholder="请选择您要上传的文件类型">
            <el-radio v-for="item of TypeList" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传文件">
          <div v-if="form.attachment_id >0">
            <div >
            <el-avatar shape="square" :size="50" :src="attachment.thumbs" ></el-avatar>
            <span class="title">{{ attachment.title }}</span>
            </div>
            <el-button
              size="mini"
              @click="dialogTableVisible = true" type="primary" plain>重新选择</el-button>
            <el-button
              size="mini"
              @click="restartSubmit" type="primary" plain>重新上传</el-button>
          </div>
          <div v-if="spark_percentage >0">
              校检进度：<el-progress  :text-inside="true" :stroke-width="26" :percentage="spark_percentage"></el-progress>
          </div>
          <div v-if="percentage >0">
              <el-progress  :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
          </div>
          <div tabindex="0" style="width:100%" v-if="spark_percentage==0 && percentage==0 && form.attachment_id == 0 " class="el-upload el-upload--text" id="big-upload"><div class="el-upload-dragger" style="width:100%"><i class="el-icon-upload"></i> <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> </div><input type="file" name="file" multiple="multiple" class="el-upload__input"></div>
          <div class="sub-title" style="color:red">文档格式：docx||pptx。视频格式：mp4，最大只能上传2G文件。其中编码要求：视频编码必须是 H.264
音频编码必须是: AAC，可以使用<a href="http://soft.onlinedown.net/soft/983615.htm"  target="_blank" style="font-weight: 800"><el-tag type="success">格式工厂</el-tag></a>转换格式</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
    <!-- Table -->
    <el-dialog title="已经上传没有使用附件" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="title" label="名称" width="250"></el-table-column>
        <el-table-column property="created_at" label="创建日期" width="150"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleShow(scope.$index, scope.row)">预览</el-button>
            <el-button
              size="mini"
              @click="handleSelect(scope.$index, scope.row)" type="success">选择</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="attachment.title" width="80%" :visible.sync="outerVisible">
      <Preview :info="attachment"></Preview>
    </el-dialog>
    <Footer></Footer>
  </div>
  
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer' 

import { getToken } from '@/utils/auth'
import { getListOptions } from '@/utils/app'
import Uploader from 'simple-uploader.js'
import Preview from '@/components/preview'
import { getCache } from '@/utils/cache'
import { ossInit, randomString, getDay } from '@/utils/oss'
import { resGetUploadConfig, resGetNoUserAttachment, attachmentAdd, attachmentDelete, resAdd } from '@/api/'

export default {
  data() {
    return {
      dialogTableVisible: false,
      outerVisible: false,
      gridData: [],
      attachment: [],
      CourseList: [],
      GradeList: [],
      TypeList: [],
      total: 0,
      form: {
        title: '',
        desc: '',
        type_id: '',
        class_id: '',
        subject_id: '',
        attachment_id: 0,
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur'}
        ],
        desc: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        class_id: [
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
        subject_id: [
          { required: true, message: '请选择科目', trigger: 'change' }
        ]
      },
      uploader: [],
      preprocess: [],
      uploader: [],
      percentage: 0,
      spark_percentage: 0,
      chunkSize: 1024 * 1024 * 1,
      loading: true,
      uploadConfig: null,
      oss: null,
      nav: {
        id: '100',
        name: '上传资源'
      }
    }
  },
  watch: {
    spark_percentage: function() {
      if (this.spark_percentage > 0) {
        this.loading.close()
      }
    },
    percentage: function() {
      if (this.percentage > 0) {
        this.loading.close()
      }
    }
  },
  components: {
    Preview, Header, Footer
  },
  computed: {},
  mounted() {
  },
  created() {
    this.getNoUserAttachment()
    this.getConfig()
  },
  methods: {
    replaceAll(s1,s2) {     
      return (new RegExp(s1,"gm"),s2)     
    },
    restartSubmit() {
      this.form.attachment_id = 0
      this.percentage = 0
      let that = this
      setTimeout(function(){
        that.upload()
      },500) 
      
    },
    onSubmit(formName) {
      if(!this.form.attachment_id) {
        this.$message.error('请先上传文件')
        return
      }
      this.$refs[formName].validate((valid) => {
          if (valid) {
            resAdd(this.form).then(res=> {
              this.$message({
                message: res,
                type: 'success',
                onClose: res => {
                  this.resetForm(formName)
                  this.$router.push({ name: 'AppResourceMy' })
                }
              })
            })
          } else {
            console.log('error submit!!')
            return false
          }
      });
      console.log('submit!');
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    getConfig() {
      let configs = getCache('configs')
      this.GradeList = configs[0]['children']
      this.CourseList = configs[1]['children']
      this.TypeList = configs[2]['children']
      if(this.oss)return
      //获取上传文件配置
      resGetUploadConfig().then(res=> {
        this.uploadConfig = res
        this.upload()
        this.oss = ossInit(res)
        // console.log(this.oss)
      })

    },
    handleSelect(index, row) {
      this.attachment = row
      this.form.attachment_id = row.id
      this.dialogTableVisible = false
    },
    handleShow(index, row) {
      this.attachment = row
      this.outerVisible = true
    },
    handleDelete(index, row) {
      attachmentDelete({id: row.id}).then(res=> {
        this.$message({
                type: 'success',
                message: '删除成功'
        })
        this.gridData.splice(index, 1)
      })
    },
    getNoUserAttachment() {
      resGetNoUserAttachment({}).then(res=>{
        this.gridData = res
        if(res.length > 0)this.dialogTableVisible = true
        
      })
    },
    upload() {
      let uploader = new Uploader({
        target: '//' + this.uploadConfig.endpoint,
        headers: {
          // 'Authorization': 'Bearer ' + getToken()
        },
        chunkSize: this.chunkSize,
        testChunks: true,
        // uploadMethod : 'POST',
        testMethod: 'POST',
        //   withCredentials : true
        fileParameterName: 'chunk'
      })
      uploader.assignBrowse(document.getElementById('big-upload'), false, true, { accept: 'image/*, video/mp4, video/mp4,application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
      uploader.assignDrop(document.getElementById('big-upload'))
      let that = this
      uploader.on('fileAdded', function(file, event) {
        if(file.size > 1073741824) {
          that.$message('最大支持2g文件', 'error')
          return
        }
        that.chunkSize = parseInt(file.size / 10)
        that.loading = that.$loading({
          lock: true,
          text: 'Loading'
        })
        let options = {
          // 获取分片上传进度、断点和返回值。
          progress: (p, cpt, res) => {
            that.percentage = parseInt(p * 100)
            console.log(p);
          },
          // 设置并发上传的分片数量。
          parallel: 4,
          // 设置分片大小。默认值为1 MB，最小值为100 KB。
          partSize: 1024 * 1024,
          mime: file.fileType,
        }
        console.log(options);
        let name = 'uploads/users/'+ that.$store.state.user.id + '/' + getDay() + '/' + randomString(15) + '.' + file.name.split('.').pop()
        console.log(file)
        let data = {
          name: file.name,
          extension: file.name.split('.').pop(),
          file: name,
          info: file
        }
        // return
        if(file.size > 1024100) {
          that.oss.multipartUpload(name, file.file, options).then(res=> {
            attachmentAdd(data).then(res=> {
              that.form.attachment_id = res.info.id
              that.form.attachment = res.info
              that.attachment = res.info
              that.$message({
                type: 'success',
                message: '上传成功！'
              })
            })
            // console.log(res)
          });
        }else{
          that.oss.put(name, file.file, options).then(res=> {
            that.percentage = 100
            attachmentAdd(data).then(res=> {
              that.form.attachment_id = res.info.id
              that.form.attachment = res.info
              that.attachment = res.info
              that.$message({
                type: 'success',
                message: '上传成功！'
              })
            })
            // console.log(res)
          });
        }
      })
      this.uploader = uploader
    },
    selectNianji(e){
      let arr
      for(let i in this.GradeList) {
        if(this.GradeList[i]['id'] == e) {
          arr = this.GradeList[i]
          break
        }
      }
      let configs = getCache('configs')
      this.CourseList = getListOptions(arr.name, configs[1]['children'])  
    }
  }
}

</script>



<style scoped>
.uploader-example {
    width: 880px;
    padding: 15px;
    margin: 40px auto 0;
    font-size: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
  }
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
  
    .form_btm{ margin:25px auto 0; background:#fff; padding: 20px;}
</style>
<style>
    .form_page .el-textarea__inner{ height:120px;}
    .form_page .el-select{ width:100%;}
</style>